import { Grid } from "@material-ui/core";
import React from "react";
import { DataCard } from "@ofqual/portal-components/components/DataCard/DataCard";
import { CommunicationJudgementModel } from "../../domain/CommunicationJudgementModel";

export const CommunicationJudgement: React.FC<{
  communicationJudgement: CommunicationJudgementModel | undefined;
}> = ({ communicationJudgement }) => {
  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DataCard
              showHeading={false}
              heading={null}
              items={[
                {
                  itemType: "MULTILINE",
                  key: "Provide details of your communication and analytical judgement skills",
                  value:
                    communicationJudgement?.communicationAnalyticalJudgementSkillsDetails ??
                    "",
                },
              ]}
              hasAction={false}
              actionDescription={null}
              actionButtonText={null}
              actionFunction={null}
              headingComponent={"h1"}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
